<template>
  <university-create-form></university-create-form>
</template>

<script>
import UniversityCreateForm from "./CreateForm";
export default {
  name: "CreateUniversityPage",
  components: { UniversityCreateForm }
};
</script>

<style scoped></style>
